module.exports = __webpack_public_path__ + "static/mail-ee9b371c5d865caabab8064d2b2c3607.svg";